import { initMentorshipSessions, sessionStatus } from "actions/mentorshipAction";
import { initQuiz, initSession, stepCompleted } from "actions/sessionAction";
import { connect } from 'react-redux';
import MentorshipSessionSummary from "views/Mentorship/MentorshipSessionSummary";
import { filter, get } from "lodash";
import { isMentee, isMentor } from "../../business/role";
import { withRouter } from "react-router";
import { isPreviewSearch } from "common/preview";

const mapStateToProps = ({
  auth: { user: { role, status } },
  session: { currentSession },
  mentorship: { currentSessionCompletedSteps, currentSessionPartnerCompletedSteps, currentMentorshipSessionProgress, partnerDetails, sessions: mentorshipSessions },
  sessionStatus: { sessions }
}, ownProps) => ({
  session: currentSession,
  completedSteps: currentSessionCompletedSteps,
  partnerCompletedSteps: currentSessionPartnerCompletedSteps,
  currentMentorshipSessionProgress,
  sessionProgress: sessions,
  mentorshipSessions,
  role,
  userDetails: get(partnerDetails, 'userDetails.[0]'),
  mentorDetails: isMentee(role) && get(filter(partnerDetails.partnerDetails, partner => isMentor(partner.role)), '[0]'),
  partnerMenteesDetails: filter(partnerDetails.partnerDetails, partner => isMentee(partner.role)),
  mentorshipType: get(status, 'mentorships[0].mentorshipType'),
  isPreview: isPreviewSearch(get(ownProps, 'location.search', '')),
});

export default withRouter(
  connect(mapStateToProps, { initQuiz, stepCompleted, sessionStatus, initSession, initMentorshipSessions })(MentorshipSessionSummary)
);
